import React from 'react';
import { Polyline, CircleMarker, Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import { getDelay, isDelayed } from './trainPosition';

const clock = (iso) => (iso ? String(iso).slice(11, 16) : null);

const endpointIcon = (faIcon, color) => L.divIcon({
  className: 'route-endpoint-icon',
  html: `<div class="route-endpoint" style="background:${color}"><i class="fa ${faIcon}"></i></div>`,
  iconSize: [22, 22],
  iconAnchor: [11, 11],
});

const stopTooltip = (station) => {
  const arr = clock(station.arrivalTime_actual || station.arrivalTime_scheduled);
  const dep = clock(station.departureTime_actual || station.departureTime_scheduled);
  const delay = Math.max(
    getDelay(station.arrivalTime_scheduled, station.arrivalTime_actual) || 0,
    getDelay(station.departureTime_scheduled, station.departureTime_actual) || 0
  );
  return (
    <Tooltip direction="top">
      <strong>{station.stationName}</strong>
      {(arr || dep) && (
        <>
          <br />
          {arr && `an ${arr}`}{arr && dep && ' · '}{dep && `ab ${dep}`}
        </>
      )}
      {delay > 0 && <><br /><span style={{ color: '#f78166' }}>+{delay} min</span></>}
    </Tooltip>
  );
};

/**
 * The complete run of the selected train: route line, both endpoints and every intermediate
 * stop — the same reading as the train detail map, only inside the live map.
 */
const TrainRouteLayer = ({ journey, color }) => {
  if (!journey || journey.stations.length < 2) return null;

  const { stations, coords } = journey;
  const first = stations[0];
  const last = stations[stations.length - 1];

  return (
    <>
      {coords.length >= 2 && (
        <>
          {/* Casing underneath so the line stays readable on busy tiles */}
          <Polyline
            positions={coords}
            pathOptions={{ color: '#0d1117', weight: 8, opacity: 0.45, lineCap: 'round' }}
          />
          <Polyline
            positions={coords}
            pathOptions={{ color, weight: 4, opacity: 0.95, lineCap: 'round' }}
          />
        </>
      )}

      {stations.slice(1, -1).map(station => {
        const late = isDelayed(station.arrivalTime_scheduled, station.arrivalTime_actual);
        return (
          <CircleMarker
            key={`${station.stationName}-${station.arrivalTime_scheduled || ''}`}
            center={[station.lat, station.lng]}
            radius={4}
            pathOptions={{
              color: '#ffffff',
              weight: 2,
              fillColor: late ? '#f78166' : color,
              fillOpacity: 1,
            }}
          >
            {stopTooltip(station)}
          </CircleMarker>
        );
      })}

      <Marker position={[first.lat, first.lng]} icon={endpointIcon('fa-play', color)}>
        {stopTooltip(first)}
      </Marker>
      <Marker position={[last.lat, last.lng]} icon={endpointIcon('fa-flag-checkered', color)}>
        {stopTooltip(last)}
      </Marker>
    </>
  );
};

export default TrainRouteLayer;
